export default __webpack_public_path__ + "static/media/first-section.12b325fd.png";